import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { FloatingWhatsApp } from 'react-floating-whatsapp';
import WAvatar from './assets/logo.jpg'; // Correct path for avatar
import Home from "./pages/home/Home";
import Login from "./pages/auth/login/Login";
import Register from "./pages/auth/register/Register";
import DisplayAllCourses from "./pages/displayAllCourses/DisplayAllCourse";
import Courses from "./pages/courses/Courses";
import Cart from "./pages/cart/Cart";
import Developer from "./Developer";
import Profile from "./pages/profile/Profile";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Video from "./pages/video/Video";
import AdminHome from "./admin/pages/AdminHome";
import Support from "./pages/support/Support";
import PayOnline from "./components/PayOnline";
import PayBank from "./components/PayBank";
import Loading from "./components/loadingPulse/LoadingBar";
import ScrollToTop from "./components/ScrollToTop";
import ReactGA from 'react-ga4';
import Forget from "./pages/forgetpw/Forget";
import BufferAnimation from "./components/bufferAnimation/BufferAnimation";
import EditProfile from "./pages/profile/EditProfile";
import VideoPlayer from "./Developer";
import DrivePlayer from "./pages/video/DrivePlayer";

import Layout from "./Admin copy/routes/layout"; 
import AdminDashboard from "./Admin copy/routes/dashboard/page"; 
import AdminRedirect from "./Admin copy/pages/AdminRedirect";
import ProtectedAdminRoute from "./Admin copy/pages/ProtectedAdminRoute";
import QuizManagement from "./Admin copy/pages/quize/QuizeManagement";
import LessonManager from "./Admin copy/pages/lessons/LessonManager";
import UserManager from "./Admin copy/pages/users/UserManager";
import Payments from "./Admin copy/pages/payments/Payments";
import QuotaManagment from "./Admin copy/pages/quota/QuotaManagment";

ReactGA.initialize('G-GMN7DQSKGS');  // google analytics

function App() {
  const [cartItems, setCartItems] = useState(() => {
    const storedItems = localStorage.getItem("cartItems");
    return storedItems ? JSON.parse(storedItems) : [];
  });
  const [isLoading, setIsLoading] = useState(false);
  const [cartItemCount, setCartItemCount] = useState(0);
  let TmpcartItems = JSON.parse(localStorage.getItem("cartItems"));

  const [isDpEdited, setIsDpEdited] = useState(false);
  const [isLogged, setIsLogged] = useState(false); // Declare the isLogged state

  useEffect(() => {
    if (TmpcartItems) {
      setCartItemCount(1);
    }
  }, []);

  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  // Google Analytics - Track page views on route change
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  // Function to get the title based on the path
  const getTitle = (pathname) => {
    switch (pathname) {
      case "/":
        return "Home | ALGuidance.lk";
      case "/login":
        return "Login | ALGuidance.lk";
      case "/register":
        return "Register | ALGuidance.lk";
      case "/courses":
        return "Courses | ALGuidance.lk";
      case "/profile":
        return "Profile | ALGuidance.lk";
      case "/cart":
        return "Cart | ALGuidance.lk";
      case "/support":
        return "Support | ALGuidance.lk";
      case "/checkout/online":
        return "Online Checkout | ALGuidance.lk";
      case "/checkout/bank":
        return "Bank Checkout | ALGuidance.lk";
      case "/video":
        return "Video | ALGuidance.lk";
      case "/admin":
        return "Admin Dashboard | ALGuidance.lk";
      default:
        return "ALGuidance.lk";
    }
  };

  useEffect(() => {
    document.title = getTitle(location.pathname);
  }, [location]);

  // Define the paths where FloatingWhatsApp should be shown
  const showWhatsApp = ["/", "/support", "/profile", "/login", "/register","/cart","/checkout/bank","/checkout/online"].includes(location.pathname);

  return (
    <div className="App">
      {isAdminRoute ? null : (
        <NavBar
          isDpEdited={isDpEdited} 
          setIsDpEdited={setIsDpEdited}
          cartItemCount={cartItemCount}
        />
      )}

      {isLoading && <Loading />}
      <ScrollToTop />

      <Routes>
        {/* Main application routes */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forget" element={<Forget />} />
        <Route path="/courses" element={<DisplayAllCourses setIsLoading={setIsLoading} />} />
        <Route path="/courses/:course_id" element={<Courses setCartItemCount={setCartItemCount} setIsLoading={setIsLoading} />} />
        <Route path="/profile" element={<Profile setIsLoading={setIsLoading} />} />
        <Route path="/profile/edit" element={<EditProfile setIsLoading={setIsLoading} />} />
        <Route path="/support/*" element={<Support />} />
        <Route path="/cart" element={<Cart setCartItemCount={setCartItemCount} setIsLoading={setIsLoading} />} />
        <Route path="/checkout/online" element={<PayOnline setCartItemCount={setCartItemCount} />} />
        <Route path="/checkout/bank" element={<PayBank setCartItemCount={setCartItemCount} />} />
        <Route path="/video/:id" element={<Video />} />
        <Route path="/driveplayer" element={<DrivePlayer />} />
        
        {/* Admin routes with proper nesting */}
        <Route path="/admin" element={<AdminRedirect />} />
        <Route path="/admin/*" element={
          <ProtectedAdminRoute>
            <Layout />
          </ProtectedAdminRoute>
        }>
          <Route path="dashboard" element={<AdminDashboard setIsLogged={setIsLogged} />} />
          <Route path="lessons" element={<LessonManager/>}/>
          <Route path="quota" element={<QuotaManagment/>}/>
          <Route path="viewuser" element={<h1 className="title text-8xl">Users</h1>} />

          <Route path="viewbankpayments" element={<h1 className="title text-8xl">Bank Payments</h1>} />
          <Route path="users" element={<UserManager/>} />
          <Route path="payments/bank" element={<Payments/>} />

          <Route path="quize" element={<QuizManagement/>} />
   
        </Route>
      </Routes>

      {!isAdminRoute && !isLoading && <Footer />}
      {isLoading && <BufferAnimation />}

      {showWhatsApp && (
        <FloatingWhatsApp
          phoneNumber="+94701486174"
          accountName="ALGuidance.lk"
          avatar={WAvatar}
          allowEsc
          allowClickAway
          notification
          notificationSound
          statusMessage="Typically replies within 1 hour"
          chatMessage="Hello there! 🤝 How can we help?"
          placeholder="Type a message.."
          darkMode={false}
        />
      )}

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  );
}

export default App;